import store from './store'

export const HasRoleDirective = function (el, binding) {
  if (!store.getters.HAS_ROLE(binding.value)) {
    el.style.display = 'none'
  }
}

export const HasPermissionDirective = function (el, binding) {
  const userRoles = JSON.parse(localStorage.getItem('user.roles'))
  if (!Object.keys(userRoles).includes('Administrador')) {
    el.style.display = 'none'
    const exists = binding.value.roles.some(el => Object.keys(store.getters.CURRENT_USER_ROLES).includes(el) &&
      store.getters.CURRENT_USER_ROLES[el].includes(binding.value.organizacion_id)
    )
    if (exists) el.style.display = 'block'
  }
}
